export default __webpack_public_path__ + "static/halloween_hero-c673e4ce43dc86e173ef1d17e1fcf978.png";